export default __webpack_public_path__ + "static/media/IMG_5340.9ab2088d.WEBP";